export default {
  eyebrow: 'Portal partener',
  title: 'Calculator taxă de serviciu',
  description: 'Estimează veniturile din taxa de serviciu generate în toate restaurantele din contul tău de partener.',
  toasts: {
    load_error: 'Nu s-au putut încărca setările tale pentru taxa de serviciu.',
  },
};
